import React, { useEffect } from 'react';
import { usePageContext } from '@xingternal/pages-common';
import PageCreatedBanner from './PageCreatedBanner';
import RepublishBanner from './RepublishBanner';
import { useCompaniesWorkflowStatusQueryQuery } from './CompaniesWorkflowStatusQuery.gql-types';

type Props = {
  companyId?: string | null;
  isDraft: boolean;
};

const CompaniesBannersContainer = ({ companyId, isDraft }: Props) => {
  const { setPageContext } = usePageContext();
  const { data, loading } = useCompaniesWorkflowStatusQueryQuery({
    skip: !companyId,
    variables: {
      id: companyId,
    },
  });

  const showPageCreatedBanner = isDraft && data?.company?.inPublicationWorkflow;
  const showRepublishBanner = isDraft && !data?.company?.inPublicationWorkflow;

  useEffect(() => {
    if (showPageCreatedBanner || showRepublishBanner) {
      setPageContext((prevState) => ({
        ...prevState,
        isShowingCompanyBanner: true,
      }));
    }
  }, [data]);

  if (loading) return null;

  if (showPageCreatedBanner) {
    return <PageCreatedBanner />;
  }

  if (showRepublishBanner) {
    return <RepublishBanner />;
  }

  return null;
};

export default CompaniesBannersContainer;
